export default "/images/calendar-sm.svg?39f53391f66b83ce06f2f5d3df98896b";